module.exports = __webpack_public_path__ + "img/xiaomi12timage5mobile.702536b8.svg";